import { DataType } from '../types/DataType'
import { Transactable } from './Transactable'
import { Transaction } from './Transaction'

export class Royalty extends Transaction /* implements Transactable { */ {
    readonly recordType = 'royalty'

    // todo: implement

    static dataType(): DataType {
        return 'royalties'
    }
}
